module.exports = __webpack_public_path__ + "static/media/potato.4ffe0187.svg";